import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ProjectsRoutingComponent} from '../projects-routing/projects-routing.component';

@Component({
  selector: 'projects-layout',
  standalone: true,
  imports: [RouterOutlet, ProjectsRoutingComponent],
  template: `
    <projects-routing>
      <router-outlet></router-outlet>
    </projects-routing>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsLayoutComponent {}
